import http from '@services/http';
import { Groups } from './interfaces';

export const fetchConnectedApps = (data: Groups.Apps.FetchConnectedApps.Request) => {
  return http.get<Groups.Apps.FetchConnectedApps.Response>(`/groups/${data.groupId}/apps/connected`);
};